/**
 * Minimal diagnostic page: ClinicalWorkspace with mock patient/visit.
 * Use /chart-debug to verify if the tooth chart renders.
 * If it shows here but not in Doctor → layout/context issue.
 * If it doesn't show here either → ToothChart or asset issue.
 */
import React from "react";
import { Link } from "react-router-dom";
import ClinicalWorkspace from "../components/doctor/clinical/ClinicalWorkspace";

const MOCK_PATIENT: import("../types/domain").Patient = {
  patient_id: "1",
  name: "Test Patient",
  gender: "M",
  age: 30,
  is_active: true
};

const MOCK_VISIT: import("../types/domain").Visit = {
  visit_id: 1,
  patient_id: "1",
  status: "WAITING",
  visit_date: "2025-02-01",
  is_locked: false
};

export default function DoctorChartTest() {
  return (
    <div style={{
      height: "calc(100vh - 90px)",
      display: "flex",
      flexDirection: "column",
      padding: "16px",
      background: "#f1f5f9"
    }}>
      <div style={{ marginBottom: "12px", display: "flex", gap: "12px", alignItems: "center" }}>
        <Link to="/doctor">← Back to Doctor</Link>
        <span style={{ fontWeight: 600, color: "#64748b" }}>Chart diagnostic (mock patient/visit)</span>
      </div>
      <div style={{ flex: 1, minHeight: 0, background: "#fff", borderRadius: "16px", overflow: "hidden" }}>
        <ClinicalWorkspace
          patient={MOCK_PATIENT}
          visit={MOCK_VISIT}
          isLocked={false}
          sessionConsultant={null}
          setSessionConsultant={() => { }}
        />
      </div>
    </div>
  );
}
